// src\app\core\interceptors\api-error.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { normalizeError } from '../utils/normalize-error';
import { ApiError } from '../models/api-error.model';

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        const apiError: ApiError = normalizeError(error);
        return throwError(() => apiError);
      })
    );
  }
}
